import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const DefaultSecretariat = () => import("@/containers/DefaultSecretariat");
const DefaultShop = () => import("@/containers/DefaultShop");

// Shared Pages
const dashboard = () => import("@/views/Dashboard");
const managerDashboard = () => import("@/views/Manager/ManagerDashboard");
const Reports = () => import("@/views/Manager/Reports");
const SalesReports = () => import("@/views/Reports/SalesReports");
const ItemReports = () => import("@/views/Manager/ItemReports");
const ItemFinancialReports = () =>
  import("@/views/Manager/ItemFinancialReports");
const changePassword = () => import("@/views/ChangePassword");
const templates = () => import("@/views/Templates");
const Rules = () => import("@/views/Manager/Rules");
const Currencies = () => import("@/views/Manager/Currencies");

const Orders = () => import("@/views/Orders");
const OrdersPerStatus = () => import("@/views/OrdersPerStatus");
const ActiveOrders = () => import("@/views/ActiveOrders");
const ActiveVipOrders = () => import("@/views/ActiveVipOrders");
const search = () => import("@/views/Search");
const OrdersToBe = () => import("@/views/OrdersToProducts");
const CustomerManagement = () => import("@/views/CustomerManagement");
const PrintPreview = () => import("@/views/PrintPreview");
const PrintPreview2 = () => import("@/views/PrintPreview2");
const FactoryPrintPreview = () => import("@/views/FactoryPrintPreview");
const FactoryItemsPrintPreview = () =>
  import("@/views/FactoryItemsPrintPreview");
const ChangeLog = () => import("@/views/ChangeLog");
const SendToFactory = () => import("@/views/SendToFactory");

const Page404 = () => import("@/views/Page404");
const Login = () => import("@/views/Login");
const ceoQuery = () => import("@/views/CEO/Query");
const managerQuery = () => import("@/views/Manager/Query");
const tradeHeadQuery = () => import("@/views/TradeHead/Query");
const salesManagerQuery = () => import("@/views/SalesManager/Query");
const secretaryNewOrder = () => import("@/views/NewOrder");
const newFastOrder = () => import("@/views/NewFastOrder");
const managerOrder = () => import("@/views/Manager/ManagerOrder");
const secretaryOrder = () => import("@/views/Secretary/SecretaryOrder");
const ceoOrder = () => import("@/views/CEO/CEO_Order");
const salesManagerOrder = () =>
  import("@/views/SalesManager/SalesManagerOrder");
const QueryOrganizerOrder = () =>
  import("@/views/QueryOrganizer/QueryOrganizerOrder");
const tradeHeadOrder = () => import("@/views/TradeHead/TradeHeadOrder");
const tradeOrder = () => import("@/views/Trade/TradeOrder");
const tradeInternOrder = () => import("@/views/TradeIntern/TradeOrder");
const TradeOrderSearch = () => import("@/views/Trade/OrderSearch");
const tradeQuery = () => import("@/views/Trade/Query");
const CustomerProfile = () => import("@/views/CustomerProfile");

// trade intern
const tradeInternDashboard = () => import("@/views/TradeIntern/Dashboard");

// factory
const FactoryDashboard = () => import("@/views/Factory/Dashboard");
const FactoryOrder = () => import("@/views/Factory/Order");
const FactoryOrders = () => import("@/views/Factory/Orders");
const FactoryOrdersArchive = () => import("@/views/Factory/OrdersArchive");
const FactoryOrderItems = () => import("@/views/Factory/OrderItems");
const FactoryOrderItemsPerStatus = () =>
  import("@/views/Factory/OrderItemsPerStatus");
const ProductionOrderItemsPerStatus = () =>
  import("@/views/Factory/ProductionItemsPerStatus");
const ProductionProcess = () => import("@/views/Factory/ProductionProcess");
const NewPackingList = () => import("@/views/Factory/NewPackingList");
const EditPackingList = () => import("@/views/Factory/EditPackingList");
const PrintPackingList = () => import("@/views/PrintPackingList");
const PrintInvoice = () => import("@/views/PrintInvoice");
const FactoryOrderItemsPerStatusId = () =>
  import("@/views/Factory/OrderItemsPerStatusId");
const FactoryOrderItemsArchive = () =>
  import("@/views/Factory/OrderItemsArchive");

const Productiontasks = () => import("@/views/Factory/ProductionTasks");
const FactoryEditOrderItems = () => import("@/views/Factory/EditOrderItems");
const FactoryEditOrder = () => import("@/views/Factory/EditOrder");

const Productiondashboard = () => import("@/views/Factory/ProductionDashboard");
// warehouse
const WarehouseDashboard = () => import("@/views/Warehouse/Dashboard");
const WarehouseSections = () => import("@/views/Warehouse/Sections");
const WarehouseProducts = () => import("@/views/Warehouse/ProductsWarehouses");
const WarehouseMaterials = () =>
  import("@/views/Warehouse/MaterialsWarehouses");
const WarehouseTools = () => import("@/views/Warehouse/ToolsWarehouses");
const Products = () => import("@/views/Warehouse/Products");
const ProductsExactSearch = () =>
  import("@/views/Warehouse/ProductsExactSearch");
const ProductsSearch = () => import("@/views/Warehouse/ProductsSearch");
const Materials = () => import("@/views/Warehouse/Materials");
const Tools = () => import("@/views/Warehouse/Tools");
const TotalWarehouse = () => import("@/views/Warehouse/TotalWarehouse");
const ProductsItem = () => import("@/views/Warehouse/Product");
const MaterialsItem = () => import("@/views/Warehouse/Material");
const ToolsItem = () => import("@/views/Warehouse/Tool");
const WarehouseProfile = () => import("@/views/Warehouse/Profile");
const ProductsProfile = () => import("@/views/Warehouse/ProductsProfile");
const MaterialsProfile = () => import("@/views/Warehouse/MaterialsProfile");
const allWarehouses = () => import("@/views/Warehouse/allWarehouses");
const Merge = () => import("@/views/Warehouse/Merge");

// HRM
const Employees = () => import("@/views/HRM/Employees");
const EmployeesReport = () => import("@/views/HRM/EmployeesReport");
const Form = () => import("@/views/HRM/Form");
const FormSent = () => import("@/views/HRM/FormSent");
const ActiveForms = () => import("@/views/HRM/ActiveForms");
const DeactiveForms = () => import("@/views/HRM/DeactiveForms");
const EditForm = () => import("@/views/HRM/EditForm");

// Query Organizer
const QueryOrganizerAnalyze = () => import("@/views/QueryOrganizer/Analyze");

// SHOP
const ShopDashboard = () => import("@/views/Shop/Dashboard");
const ShopCustomers = () => import("@/views/Shop/Customers");
const ShopCustomer = () => import("@/views/Shop/Customer");
const ShopPayments = () => import("@/views/Shop/Payments");
// const ShopNewPayment = () => import("@/views/Shop/NewPayment");
const ShopProducts = () => import("@/views/Shop/Products");
const ShopProduct = () => import("@/views/Shop/Product");
const ShopInvoice = () => import("@/views/Shop/Invoice");
const ShopPreInvoice = () => import("@/views/Shop/PreInvoice");
const ShopSalesInvoices = () => import("@/views/Shop/SalesInvoices");
const ShopPurchaseInvoices = () => import("@/views/Shop/PurchaseInvoices");
const ShopNewSalesInvoice = () => import("@/views/Shop/NewSalesInvoice");
const ShopNewPurchaseInvoice = () => import("@/views/Shop/NewPurchaseInvoice");
const ChequesList = () => import("@/views/Shop/ChequesList");
const shopReports = () => import("@/views/Shop/Reports");
// NewShop
const PassWordChange = () => import("@/views/NewShop/PassWordChange");
const NewInvoice = () => import("@/views/NewShop/NewInvoice");
const NewProforma = () => import("@/views/NewShop/NewProforma");
const CustomersClub = () => import("@/views/NewShop/CustomersClub");
const Settings = () => import("@/views/NewShop/Settings");
const NewCustomers = () => import("@/views/NewShop/Customers");
const NewCustomer = () => import("@/views/NewShop/Customer");
const NewProducts = () => import("@/views/NewShop/Products");
const NewShopDashboard = () => import("@/views/NewShop/Dashboard");
const NewPaymentList = () => import("@/views/NewShop/PaymentList");
const NewShopSalesInvoices = () => import("@/views/NewShop/SalesInvoices");
const ProformaList = () => import("@/views/NewShop/ProformaList");
const NewShopInvoices = () => import("@/views/NewShop/Invoice");
const NewShopEditInvoices = () => import("@/views/NewShop/EditInvoice");
const PaymentList = () => import("@/views/NewShop/PaymentList");
const PrintShop = () => import("@/views/NewShop/PrintShop");
const RialSalesReport = () => import("@/views/NewShop/RialSalesReport");
const ReturnedRialReport = () => import("@/views/NewShop/ReturnedRialReport");
const ReturnedAmountReport = () =>
  import("@/views/NewShop/ReturnedAmountReport");
const amountSalesReport = () => import("@/views/NewShop/amountSalesReport");
const reports = () => import("@/views/NewShop/Reports");

// ACCOUNTING
const AccountingNewInvoice = () => import("@/views/Accounting/NewInvoice");
const AccountingEditInvoice = () => import("@/views/Accounting/EditInvoice");

// GENERAL
const GeneralDashboard = () => import("@/views/General/Dashboard");

// Secretariat
const SecretariatDash = () => import("@/views/Secretariat/Dashboard");
// ----- Inbox -----
const SecretariatInbox = () => import("@/views/Secretariat/Inbox/InboxLetters");
const InboxLetterId = () => import("@/views/Secretariat/Inbox/InboxLetterId");
const InboxRelatedLetters = () =>
  import("@/views/Secretariat/Inbox/InboxRelatedLetters");
const InboxNewLetter = () => import("@/views/Secretariat/Inbox/InboxNewLetter");
const InboxReplyLetter = () => import("@/views/Secretariat/Inbox/InboxReply");
const InboxEditLetter = () => import("@/views/Secretariat/Inbox/InboxEdit");

// ----- Outbox -----
const SecretariatOutbox = () =>
  import("@/views/Secretariat/Outbox/OutboxLetters");
const OutboxLetterId = () =>
  import("@/views/Secretariat/Outbox/OutboxLetterId");
const OutboxRelatedLetters = () =>
  import("@/views/Secretariat/Outbox/OutboxRelatedLetters");
const OutboxNewLetter = () =>
  import("@/views/Secretariat/Outbox/OutboxNewLetter");
const OutboxReplyLetter = () =>
  import("@/views/Secretariat/Outbox/OutboxReply");
const OutboxEditLetter = () => import("@/views/Secretariat/Outbox/OutboxEdit");

// ----- Internal -----
const SecretariatInternal = () =>
  import("@/views/Secretariat/Internal/InternalLetters");
const InternalLetterId = () =>
  import("@/views/Secretariat/Internal/InternalLetterId");
const InternalRelatedLetters = () =>
  import("@/views/Secretariat/Internal/InternalRelatedLetters");
const InternalNewLetter = () =>
  import("@/views/Secretariat/Internal/InternalNewLetter");
const InternalReplyLetter = () =>
  import("@/views/Secretariat/Internal/InternalReply");
const InternalEditLetter = () =>
  import("@/views/Secretariat/Internal/InternalEdit");

// ----- AssignedLetters -----
const AssignedLetters = () => import("@/views/Secretariat/AssignedLetters");

// ----- Signature -----
const WaitingList = () =>
  import("@/views/Secretariat/Signature/WaitingLettersList");
const SubmitSignature = () =>
  import("@/views/Secretariat/Signature/SubmitSignature");

// ----- Reminders -----
const RemindersList = () => import("@/views/Secretariat/RemindersList");
const RemindersArchiveList = () =>
  import("@/views/Secretariat/RemindersArchive");

// ----- Drafts -----
const DraftsList = () => import("@/views/Secretariat/Drafts/DraftLettersList");
const CompleteDraft = () => import("@/views/Secretariat/Drafts/CompleteDraft");

// ----- Saved Letters -----
const MarkedLetters = () => import("@/views/Secretariat/MarkedLetters");

// ----- Archives -----
const ArchivesList = () => import("@/views/Secretariat/ArchivesList");

// ----- Templates -----
const Templates = () => import("@/views/Secretariat/Templates");

// ----- Chat -----
const AllChats = () => import("@/views/Chat/AllChats");
const ChatId = () => import("@/views/Chat/ChatId");
const VideoCall = () => import("@/views/Chat/VideoCall");

export default new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: localStorage.role ? localStorage.role + "/dashboard" : "/login",
      name: "خانه",
      component: DefaultContainer,
      children: [
        {
          path: "/changelog",
          name: "تغییرات هر نسخه",
          component: ChangeLog,
        },
        {
          path: "/Manager/currencies",
          name: "واحدهای پولی",
          component: Currencies,
        },
        {
          path: "/allChats",
          name: "فهرست گفتمان",
          component: AllChats,
        },

        {
          path: "/:role/secretariat/dashboard",
          name: "",
          component: DefaultSecretariat,
          children: [
            {
              path: "/:role/secretariat/dashboard",
              name: "دبیرخانه",
              component: SecretariatDash,
            },
            {
              path: "/:role/secretariat/inbox",
              name: "صندوق ورودی",
              component: SecretariatInbox,
              children: [
                {
                  path: "/:role/secretariat/inbox/letterInfo/:id",
                  name: "مشاهده نامه",
                  component: InboxLetterId,
                  children: [
                    {
                      path: "/:role/secretariat/inbox/letterInfo/relatedLetters/:id",
                      name: "نامه‌های مرتبط",
                      component: InboxRelatedLetters,
                    },
                  ],
                },
                {
                  path: "/:role/secretariat/inbox/newLetter",
                  name: "نامه ورودی جدید",
                  component: InboxNewLetter,
                },
                {
                  path: "/:role/secretariat/inbox/reply/:id",
                  name: "ارسال پاسخ",
                  component: InboxReplyLetter,
                },
                {
                  path: "/:role/secretariat/inbox/edit/:id",
                  name: "ویرایش نامه ورودی",
                  component: InboxEditLetter,
                },
              ],
            },
            {
              path: "/:role/secretariat/outbox",
              name: "صندوق خروجی",
              component: SecretariatOutbox,
              children: [
                {
                  path: "/:role/secretariat/outbox/letterInfo/:id",
                  name: "مشاهده نامه",
                  component: OutboxLetterId,
                  children: [
                    {
                      path: "/:role/secretariat/outbox/letterInfo/relatedLetters/:id",
                      name: "نامه‌های مرتبط",
                      component: OutboxRelatedLetters,
                    },
                  ],
                },
                {
                  path: "/:role/secretariat/outbox/newLetter",
                  name: "نامه خروجی جدید",
                  component: OutboxNewLetter,
                },
                {
                  path: "/:role/secretariat/outbox/reply/:id",
                  name: "ارسال پاسخ",
                  component: OutboxReplyLetter,
                },
                {
                  path: "/:role/secretariat/outbox/edit/:id",
                  name: "ویرایش نامه خروجی",
                  component: OutboxEditLetter,
                },
              ],
            },
            {
              path: "/:role/secretariat/internal",
              name: "صندوق سازمانی",
              component: SecretariatInternal,
              children: [
                {
                  path: "/:role/secretariat/internal/letterInfo/:id",
                  name: "مشاهده نامه",
                  component: InternalLetterId,
                  children: [
                    {
                      path: "/:role/secretariat/internal/letterInfo/relatedLetters/:id",
                      name: "نامه‌های مرتبط",
                      component: InternalRelatedLetters,
                    },
                  ],
                },
                {
                  path: "/:role/secretariat/internal/newLetter",
                  name: "نامه سازمانی جدید",
                  component: InternalNewLetter,
                },
                {
                  path: "/:role/secretariat/internal/reply/:id",
                  name: "ارسال پاسخ",
                  component: InternalReplyLetter,
                },
                {
                  path: "/:role/secretariat/internal/edit/:id",
                  name: "ویرایش نامه سازمانی",
                  component: InternalEditLetter,
                },
              ],
            },
            {
              path: "/:role/secretariat/assignedLetters",
              name: "تخصیص به من",
              component: AssignedLetters,
            },
            {
              path: "/:role/secretariat/waitingList",
              name: "درانتظار امضا",
              component: WaitingList,
            },
            {
              path: "/:role/secretariat/waitingList/submitSignature/:id",
              name: "ثبت امضا و ارسال",
              component: SubmitSignature,
            },
            {
              path: "/:role/secretariat/reminders",
              name: "یادآوری پیگیری",
              component: RemindersList,
            },
            {
              path: "/:role/secretariat/reminderArchive",
              name: "تاریخچه پیگیری‌ها",
              component: RemindersArchiveList,
            },
            {
              path: "/:role/secretariat/drafts",
              name: "پیش‌نویس",
              component: DraftsList,
            },
            {
              path: "/:role/secretariat/drafts/CompleteDraft/:id",
              name: "تکمیل پیش‌ نویس",
              component: CompleteDraft,
            },
            {
              path: "/:role/secretariat/markedLetters",
              name: "نشان شده‌ها",
              component: MarkedLetters,
            },
            {
              path: "/:role/secretariat/archives",
              name: "بایگانی",
              component: ArchivesList,
            },
            {
              path: "/:role/secretariat/letterTemplates",
              name: "قالب‌های نامه",
              component: Templates,
            },
          ],
        },
        {
          path: "/Manager/sendToFactory/:id",
          name: "ارسال به کارخانه",
          component: SendToFactory,
        },
        {
          path: "/trade/sendToFactory/:id",
          name: "ارسال به کارخانه",
          component: SendToFactory,
        },
        {
          path: "/tradeHead/sendToFactory/:id",
          name: "ارسال به کارخانه",
          component: SendToFactory,
        },
        {
          path: "/salesManager/sendToFactory/:id",
          name: "ارسال به کارخانه",
          component: SendToFactory,
        },
        {
          path: "/:role/changePassword",
          name: "تغییر رمزعبور",
          component: changePassword,
        },

        {
          path: "/ceo/dashboard",
          name: "داشبورد مدیرعامل",
          component: managerDashboard,
        },
        {
          path: "/ceo/reports",
          name: "گزارش‌های مدیرعامل",
          component: Reports,
        },
        {
          path: "/Manager/query/:customer/:id",
          name: "تعیین قیمت مدیر",
          component: managerQuery,
        },
        {
          path: "/tradeHead/query/:customer/:id",
          name: "تعیین قیمت کارشناس فنی",
          component: tradeHeadQuery,
        },
        {
          path: "/salesManager/query/:customer/:id",
          name: "تعیین قیمت مدیرفروش",
          component: salesManagerQuery,
        },
        {
          path: "/secretary/orders",
          name: "آرشیو استعلام‌ها (منشی)",
          component: Orders,
        },
        {
          path: "/secretaryStatus/orders",
          name: "آرشیو استعلام‌ها (منشی)",
          component: Orders,
        },
        {
          path: "/trade/orders",
          name: "آرشیو استعلام‌ها (کارشناس)",
          component: Orders,
        },
        {
          path: "/tradeIntern/orders",
          name: "آرشیو استعلام‌ها (کارآموز بازرگانی)",
          component: Orders,
        },
        {
          path: "/ceo/orders",
          name: "آرشیو استعلام‌ها (مدیرعامل)",
          component: Orders,
        },
        {
          path: "/Manager/orders",
          name: "آرشیو استعلام‌ها (مدیر)",
          component: Orders,
        },
        {
          path: "/tradeHead/orders",
          name: "آرشیو استعلام‌ها (سرپرست)",
          component: Orders,
        },
        {
          path: "/queryOrganizer/orders",
          name: "آرشیو استعلام‌ها (بازرس)",
          component: Orders,
        },
        {
          path: "/salesManager/orders",
          name: "آرشیو استعلام‌ها (مدیرفروش)",
          component: Orders,
        },
        {
          path: "/:role/ordersPerStatus/:id",
          name: "استعلام‌ها",
          component: OrdersPerStatus,
        },
        {
          path: "/secretary/activeOrders",
          name: "استعلام‌های فعال (منشی)",
          component: ActiveOrders,
        },
        {
          path: "/secretaryStatus/activeOrders",
          name: "استعلام‌های فعال (منشی)",
          component: ActiveOrders,
        },
        {
          path: "/trade/activeOrders",
          name: "استعلام‌های فعال (کارشناس)",
          component: ActiveOrders,
        },
        {
          path: "/ceo/activeOrders",
          name: "استعلام‌های فعال (مدیرعامل)",
          component: ActiveOrders,
          children: [
            {
              path: "/ceo/query/:customer/:id",
              name: "تعیین قیمت مدیرعامل",
              component: ceoQuery,
            },
          ],
        },
        {
          path: "/Manager/activeOrders",
          name: "استعلام‌های فعال (مدیر)",
          component: ActiveOrders,
        },
        {
          path: "/tradeHead/activeOrders",
          name: "استعلام‌های فعال (سرپرست)",
          component: ActiveOrders,
        },
        {
          path: "/salesManager/activeOrders",
          name: "استعلام‌های فعال (مدیرفروش)",
          component: ActiveOrders,
        },
        {
          path: "/secretary/activeVipOrders",
          name: "استعلام‌های فعال مشتریان ویژه (منشی)",
          component: ActiveVipOrders,
        },
        {
          path: "/secretaryStatus/activeVipOrders",
          name: "استعلام‌های فعال مشتریان ویژه (منشی)",
          component: ActiveVipOrders,
        },
        {
          path: "/trade/activeVipOrders",
          name: "استعلام‌های فعال مشتریان ویژه (کارشناس)",
          component: ActiveVipOrders,
        },
        {
          path: "/ceo/activeVipOrders",
          name: "استعلام‌های فعال مشتریان ویژه (مدیرعامل)",
          component: ActiveVipOrders,
          children: [
            {
              path: "/ceo/query/:customer/:id",
              name: "تعیین قیمت مدیرعامل",
              component: ceoQuery,
            },
          ],
        },
        {
          path: "/Manager/activeVipOrders",
          name: "استعلام‌های فعال مشتریان ویژه (مدیر)",
          component: ActiveVipOrders,
        },
        {
          path: "/tradeHead/activeVipOrders",
          name: "استعلام‌های فعال مشتریان ویژه (سرپرست)",
          component: ActiveVipOrders,
        },
        {
          path: "/salesManager/activeVipOrders",
          name: "استعلام‌های فعال مشتریان ویژه (مدیرفروش)",
          component: ActiveVipOrders,
        },
        {
          path: "/ceo/search",
          name: "جستجوی جامع (مدیرعامل)",
          component: search,
        },
        {
          path: "/trade/search",
          name: "جستجوی جامع (کارشناس)",
          component: search,
        },
        {
          path: "/tradeHead/search",
          name: "جستجوی جامع (سرپرست)",
          component: search,
        },
        {
          path: "/salesManager/search",
          name: "جستجوی جامع (مدیرفروش)",
          component: search,
        },
        {
          path: "/secretary/search",
          name: "جستجوی جامع (منشی)",
          component: search,
        },
        {
          path: "/secretaryStatus/search",
          name: "جستجوی جامع (منشی)",
          component: search,
        },
        {
          path: "/Manager/search",
          name: "جستجوی جامع (مدیر)",
          component: search,
        },
        {
          path: "/accountant/search",
          name: "جستجوی جامع (حسابدار)",
          component: search,
        },
        {
          path: "/ceo/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (مدیرعامل)",
          component: OrdersToBe,
        },
        {
          path: "/trade/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (کارشناس)",
          component: OrdersToBe,
        },
        {
          path: "/tradeHead/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (سرپرست)",
          component: OrdersToBe,
        },
        {
          path: "/secretary/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (منشی)",
          component: OrdersToBe,
        },
        {
          path: "/secretaryStatus/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (منشی)",
          component: OrdersToBe,
        },
        {
          path: "/Manager/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (مدیر)",
          component: OrdersToBe,
        },
        {
          path: "/salesManager/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (مدیرفروش)",
          component: OrdersToBe,
        },
        {
          path: "/queryOrganizer/orderstoProducts",
          name: "استعلام‌های آماده ارسال به کارخانه (بازرس)",
          component: OrdersToBe,
        },
        {
          path: "/:role/templates",
          name: "الگوهای سازمانی",
          component: templates,
        },
        {
          path: "/:role/rules",
          name: "قوانین استعلام",
          component: Rules,
        },
        {
          path: "/secretary/dashboard",
          name: "داشبورد منشی",
          component: dashboard,
        },
        {
          path: "/secretaryStatus/dashboard",
          name: "داشبورد منشی",
          component: dashboard,
        },
        {
          path: "/secretary/newOrder",
          name: "ثبت استعلام جدید",
          component: secretaryNewOrder,
        },
        {
          path: "/secretaryStatus/newOrder",
          name: "ثبت استعلام جدید",
          component: secretaryNewOrder,
        },
        {
          path: "/manager/newOrder",
          name: "ثبت استعلام جدید",
          component: secretaryNewOrder,
        },
        {
          path: "/manager/newFastOrder",
          name: "ثبت سفارش سریع جدید",
          component: newFastOrder,
        },
        {
          path: "/salesManager/newFastOrder",
          name: "ثبت سفارش سریع جدید",
          component: newFastOrder,
        },
        {
          path: "/:role/customerManagement",
          name: "مدیریت مشتری‌ها",
          component: CustomerManagement,
          children: [
            {
              path: "/:role/customerProfile/:id",
              name: "جدول استعلام‌های مشتری",
              component: CustomerProfile,
            },
          ],
        },
        {
          path: "/ceo/order/:id",
          name: "پرونده استعلام مشتری (مدیرعامل)",
          component: ceoOrder,
        },
        {
          path: "/trade/order/:id",
          name: "پرونده استعلام مشتری (کارشناس)",
          component: tradeOrder,
        },
        {
          path: "/tradeIntern/order/:id",
          name: "پرونده استعلام مشتری (کارآموز)",
          component: tradeInternOrder,
        },
        {
          path: "/tradeHead/order/:id",
          name: "پرونده استعلام مشتری (سرپرست)",
          component: tradeHeadOrder,
        },
        {
          path: "/salesManager/order/:id",
          name: "پرونده استعلام مشتری (مدیرفروش)",
          component: salesManagerOrder,
        },
        {
          path: "/queryOrganizer/order/:id",
          name: "پرونده استعلام مشتری (بازرس)",
          component: salesManagerOrder,
        },
        {
          path: "/secretary/order/:id",
          name: "پرونده استعلام مشتری (منشی)",
          component: secretaryOrder,
        },
        {
          path: "/secretaryStatus/order/:id",
          name: "پرونده استعلام مشتری (منشی)",
          component: secretaryOrder,
        },
        {
          path: "/Manager/order/:id",
          name: "پرونده استعلام مشتری (مدیر)",
          component: managerOrder,
        },
        {
          path: "/Manager/dashboard",
          name: "داشبورد مدیر ",
          component: managerDashboard,
        },
        {
          path: "/Manager/itemReports",
          name: "گزارش‌های اقلام",
          component: ItemReports,
        },
        {
          path: "/Manager/itemFinancialReports",
          name: "گزارش‌های مالی اقلام",
          component: ItemFinancialReports,
        },
        {
          path: "/Manager/reports",
          name: "گزارش‌های مدیر",
          component: Reports,
        },
        {
          path: "/ceo/reports",
          name: "گزارش‌های مدیر",
          component: Reports,
        },
        {
          path: "/:role/salesReports",
          name: "گزارش‌های فروش",
          component: SalesReports,
        },
        {
          path: "/trade/dashboard",
          name: "داشبورد کارشناس ",
          component: dashboard,
        },
        {
          path: "/tradeIntern/dashboard",
          name: "داشبورد کارآموز ",
          component: tradeInternDashboard,
        },
        {
          path: "/tradeHead/dashboard",
          name: "داشبورد سرپرست ",
          component: dashboard,
        },
        {
          path: "/salesManager/dashboard",
          name: "داشبورد فروش ",
          component: dashboard,
        },
        {
          path: "/trade/orderSearch",
          name: "جستجوی سفارش‌ها",
          component: TradeOrderSearch,
        },
        {
          path: "/trade/query/:customer/:id",
          name: " ارسال پیشنهاد فنی و مالی ",
          component: tradeQuery,
        },

        // factory
        {
          path: "/factory/dashboard",
          name: "داشبورد کارخانه",
          component: FactoryDashboard,
        },
        {
          path: "/factory/order/:id",
          name: "پرونده سفارش",
          component: FactoryOrder,
        },
        {
          path: "/factory/orders",
          name: "سفارش‌های جاری",
          component: FactoryOrders,
        },
        {
          path: "/factory/ordersArchive",
          name: "آرشیو سفارش‌ها",
          component: FactoryOrdersArchive,
        },
        // {
        //   path: "/factory/orderItems",
        //   name: "اقلام سفارش جاری",
        //   component: FactoryOrderItems,
        // },
        {
          path: "/factory/orderItemsPerStatus",
          name: "اقلام سفارش به تفکیک وضعیت",
          component: FactoryOrderItemsPerStatus,
        },
        {
          path: "/factory/productionItemsPerStatus",
          name: "اقلام تولید",
          component: ProductionOrderItemsPerStatus,
        },
        {
          path: "/factory/productionProcess",
          name: "روند تولید",
          component: ProductionProcess,
        },
        {
          path: "/factory/newPackingList/:id",
          name: "پکینگ  لیست جدید",
          component: NewPackingList,
        },
        {
          path: "/factory/editPackingList/:id",
          name: "ویرایش پکینگ  لیست",
          component: EditPackingList,
        },
        {
          path: "/factory/orderItemsPerStatusId/:id",
          name: "اقلام سفارش به تفکیک وضعیت",
          component: FactoryOrderItemsPerStatusId,
        },
        // {
        //   path: "/factory/orderItemsArchive",
        //   name: "آرشیو اقلام سفارش‌ها",
        //   component: FactoryOrderItemsArchive,
        // },
        {
          path: "/factory/editOrderItems/:id",
          name: "ویرایش اقلام سفارش",
          component: FactoryEditOrderItems,
        },
        {
          path: "/:role/productionTasks",
          name: "اقلام در حال تولید",
          component: Productiontasks,
        },
        {
          path: "/factory/editOrder/:id",
          name: "ویرایش سفارش",
          component: FactoryEditOrder,
        },
        {
          path: "/:role/productionDashboard",
          name: "داشبورد کارخانه",
          component: Productiondashboard,
        },
        //warehouse
        {
          path: "/warehouse/dashboard",
          name: "داشبورد انبار",
          component: WarehouseDashboard,
        },
        {
          path: "/warehouse/sections/:id",
          name: "بخش‌های انبار",
          component: WarehouseSections,
        },
        {
          path: "/warehouse/allWarehouses",
          name: "انبارها",
          component: allWarehouses,
        },
        {
          path: "/warehouse/productsWarehouses",
          name: "انبار محصولات",
          component: WarehouseProducts,
        },
        {
          path: "/warehouse/toolsWarehouses",
          name: "انبار ملزومات",
          component: WarehouseTools,
        },
        {
          path: "/warehouse/materialsWarehouses",
          name: "انبار مواد اولیه",
          component: WarehouseMaterials,
        },
        {
          path: "/warehouse/products",
          name: "محصولات",
          component: Products,
        },
        {
          path: "/warehouse/productsExactSearch",
          name: "جستجوی دقیق محصولات",
          component: ProductsExactSearch,
        },
        {
          path: "/warehouse/productsSearch",
          name: "جستجوی محصولات",
          component: ProductsSearch,
        },
        {
          path: "/warehouse/tools",
          name: "ملزومات",
          component: Tools,
        },
        {
          path: "/warehouse/materials",
          name: "مواد اولیه",
          component: Materials,
        },
        {
          path: "/warehouse/total",
          name: "کل انبار",
          component: TotalWarehouse,
        },
        {
          path: "/warehouse/product/:id",
          name: "پروفایل محصول",
          component: ProductsItem,
        },
        {
          path: "/warehouse/tool/:id",
          name: "پروفایل ملزومات",
          component: ToolsItem,
        },
        {
          path: "/warehouse/material/:id",
          name: "پروفایل ماده اولیه",
          component: MaterialsItem,
        },
        {
          path: "/warehouse/profile/:id",
          name: "مشاهده انبار",
          component: WarehouseProfile,
        },
        {
          path: "/warehouse/productsProfile",
          name: "رسید و حواله‌های محصولات",
          component: ProductsProfile,
        },
        {
          path: "/warehouse/materialsProfile",
          name: "رسید و حواله‌های مواد اولیه",
          component: MaterialsProfile,
        },
        ,
        {
          path: "/warehouse/merge",
          name: "ادغام دو محصول",
          component: Merge,
        },

        // HRM

        {
          path: "/hrm/employees",
          name: "مدیریت پرسنل",
          component: Employees,
        },
        {
          path: "/hrm/reports",
          name: "گزارش منابع انسانی",
          component: EmployeesReport,
        },
        {
          path: "/hrm/activeforms/",
          name: "فرم‌های فعال",
          component: ActiveForms,
        },
        {
          path: "/hrm/deactiveforms/",
          name: "فرم‌های غیرفعال",
          component: DeactiveForms,
        },
        {
          path: "/hrm/editform/:id",
          name: "ویرایش فرم",
          component: EditForm,
        },

        // Query Organizer

        {
          path: "/queryOrganizer/analyze/:id",
          name: "بررسی استعلام قبل از ارسال به کارخانه",
          component: QueryOrganizerAnalyze,
        },

        // NewShop
        {
          path: "/shop/dashboard",
          name: "",
          component: DefaultShop,
          children: [
            {
              path: "/shop/customers",
              name: "مشتریان",
              component: NewCustomers,
            },
            {
              path: "/shop/customer/:id",
              name: "پروفایل مشتری",
              component: NewCustomer,
            },
            {
              path: "/shop/products",
              name: "محصولات",
              component: NewProducts,
            },
            {
              path: "/shop/dashboard",
              name: "داشبورد",
              component: NewShopDashboard,
            },
            {
              path: "/shop/paymentlist",
              name: "پرداخت ها",
              component: NewPaymentList,
            },
            {
              path: "/shop/salesinvoices",
              name: "فاکتور فروش",
              component: NewShopSalesInvoices,
            },
            {
              path: "/shop/proformaList",
              name: "پیش‌فاکتور",
              component: ProformaList,
            },
            {
              path: "/shop/club",
              name: "باشگاه مشتریان",
              component: CustomersClub,
            },
            {
              path: "/shop/settings",
              name: "تنظیمات",
              component: Settings,
            },
            {
              path: "/shop/newinvoice",
              name: "فاکتور جدید",
              component: NewInvoice,
            },
            {
              path: "/shop/newproforma",
              name: "پیش‌فاکتور جدید",
              component: NewInvoice,
            },
            {
              path: "/shop/passwordchange",
              name: "تغییر رمز عبور",
              component: PassWordChange,
            },
            {
              path: "/shop/invoice/:id",
              name: "جزئیات فاکتور",
              component: NewShopInvoices,
            },
            {
              path: "/shop/EditInvoice/:id",
              name: "ویرایش فاکتور",
              component: NewShopEditInvoices,
            },
            {
              path: "/shop/paymentlist",
              name: "لیست پرداخت‌ها",
              component: PaymentList,
            },
            {
              path: "/shop/rialsalesreport",
              name: "چارت",
              component: RialSalesReport,
            },
            {
              path: "/shop/ReturnedRialReport",
              name: "گزارش ریالی مرجوعی",
              component: ReturnedRialReport,
            },
            {
              path: "/shop/amountSalesReport",
              name: "گزارش‌ تعداد فروش",
              component: amountSalesReport,
            },
            {
              path: "/shop/ReturnedAmountReport",
              name: "گزارش تعداد مرجوعی",
              component: ReturnedAmountReport,
            },
            {
              path: "/shop/reports",
              name: "گزارش تعداد مرجوعی",
              component: reports,
            },
          ],
        },

        // ACCOUNTING
        {
          path: "/accounting/newInvoice/:id",
          name: "صدور فاکتور جدید",
          component: AccountingNewInvoice,
        },
        {
          path: "/accounting/editInvoice/:id",
          name: "صدور فاکتور جدید",
          component: AccountingEditInvoice,
        },

        // {
        //   path: "/print/:type/:id",
        //   name: "پرینت فاکتور",
        //   component: PrintShop,
        // },
        // {
        //   path: "/newshop/customers",
        //   name: "مشتریان فروشگاه",
        //   component: NewCustomers,
        // },
        // {
        //   path: "/newshop/customer/:id",
        //   name: "پروفایل مشتری",
        //   component: NewCustomer,
        // },
        // {
        //   path: "/newshop/dashboard",
        //   name: "داشبورد",
        //   component: NewShopDashboard,
        // },
        // {
        //   path: "/newshop/products",
        //   name: "محصولات فروشگاه",
        //   component: NewProducts,
        // },
        // {
        //   path: "/newshop/salesinvoices",
        //   name: "فاکتور فروش",
        //   component: NewShopSalesInvoices,
        // },
        // {
        //   path: "/newshop/invoice/:id",
        //   name: "جزئیات فاکتور",
        //   component: NewShopInvoices,
        // },
        // {
        //   path: "/newshop/EditInvoice/:id",
        //   name: "ویرایش فاکتور",
        //   component: NewShopEditInvoices,
        // },

        // SHOP
        // {
        //   path: "/shop/dashboard",
        //   name: "داشبورد فروشگاه",
        //   component: ShopDashboard
        // },
        // {
        //   path: "/shop/products",
        //   name: "محصولات فروشگاه",
        //   component: ShopProducts,
        // },
        // {
        //   path: "/shop/product/:id",
        //   name: "پروفایل محصول",
        //   component: ShopProduct,
        // },
        // {
        //   path: "/shop/customers",
        //   name: "مشتریان",
        //   component: ShopCustomers,
        // },
        // {
        //   path: "/shop/customer/:id",
        //   name: "پروفایل مشتری",
        //   component: ShopCustomer,
        // },
        // {
        //   path: "/shop/payments",
        //   name: "دریافت‌ها",
        //   component: ShopPayments,
        // },
        // {
        //   path: "/shop/newPayent",
        //   name: "پرداخت جدید",
        //   component: ShopNewPayment,
        // },
        // {
        //   path: "/shop/invoice/:id",
        //   name: "مشاهده فاکتور",
        //   component: ShopInvoice,
        // },
        // {
        //   path: "/shop/salesInvoices",
        //   name: "مشاهده فاکتورهای فروش",
        //   component: ShopSalesInvoices,
        // },
        // {
        //   path: "/shop/purchaseInvoices",
        //   name: "مشاهده فاکتورهای خرید",
        //   component: ShopPurchaseInvoices,
        // },
        // {
        //   path: "/shop/preInvoices",
        //   name: "مشاهده پیش فاکتورها",
        //   component: ShopPreInvoice,
        // },
        // {
        //   path: "/shop/newSalesInvoice",
        //   name: "صدور فاکتور فروش",
        //   component: ShopNewSalesInvoice,
        // },
        // {
        //   path: "/shop/newPurchaseInvoice",
        //   name: "صدور فاکتور خرید",
        //   component: ShopNewPurchaseInvoice,
        // },
        // {
        //   path: "/shop/chequesList",
        //   name: "لیست چک‌ها",
        //   component: ChequesList,
        // },
        // {
        //   path: "/shop/reports",
        //   name: "گزارش‌ها",
        //   component: shopReports,
        // },
        // NewShop
        // {
        //   path: "/NewShop/PassWordChange",
        //   name: "تغییر رمز عبور",
        //   component: PassWordChange,
        // },
        // {
        //   path: "/NewShop/NewInvoice",
        //   name: "فاکتور جدید",
        //   component: NewInvoice,
        // },
        // {
        //   path: "/NewShop/CustomersClub",
        //   name: "فاکتور جدید",
        //   component: CustomersClub,
        // },

        // ALL ROLES DASHBOARD
        {
          path: "/:role/dashboard",
          name: "داشبورد",
          component: GeneralDashboard,
        },
      ],
    },
    { path: "*", component: Page404 },
    {
      path: "/recruitmentform",
      name: "form",
      component: Form,
    },
    {
      path: "/recruitmentFormSent",
      name: "تایید ارسال فرم",
      component: FormSent,
    },
    {
      path: "/chat/:id",
      name: "صفحه گفتمان",
      component: ChatId,
    },
    {
      path: "/videoCall/:id",
      name: "صفحه تماس ویدیویی",
      component: VideoCall,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    {
      path: "/printPreview/:type/:id",
      name: "پیش‌نمایش پرینت",
      component: PrintPreview2,
    },
    {
      path: "/printPackingList/:id",
      name: "چاپ پکینگ  لیست",
      component: PrintPackingList,
    },
    {
      path: "/printInvoice/:id",
      name: "چاپ فاکتور",
      component: PrintInvoice,
    },
    {
      path: "/print/:type/:invoiceType/:id",
      name: "پرینت فاکتور",
      component: PrintShop,
    },
    {
      path: "/printPreview/:id",
      name: "پیش‌نمایش پرینت کارخانه",
      component: FactoryPrintPreview,
    },
    {
      path: "/itemsPrintPreview/:id",
      name: "پیش‌نمایش پرینت اقلام کارخانه",
      component: FactoryItemsPrintPreview,
    },
    {
      path: "/:role/printPreview/:type/:id",
      name: "پیش‌نمایش پرینت",
      component: PrintPreview,
    },
  ],
});
